<template>
  <div>
    <div v-if="selectedTransformer" :key="key">
      <div class="d-flex justify-content-between align-items-center mb-5">
        <h5>
          {{ $t("mapping.configurationTitle", { label: title }) }} -
          {{ fieldType }}
        </h5>
      </div>
      <div>
        <b-tabs v-model="tabIndex" content-class="mt-3">
          <b-tab :title="$t('mapping.transformerConfigurationBasic')">
            <Basic :transformer="transformer" />
          </b-tab>
          <b-tab :title="$t('mapping.transformerConfigurationConditions')">
            <Conditions
              :tab-index="tabIndex"
              :conditions="transformer.conditions"
              :transformer="transformer"
              :parent-field-type="fieldType"
            />
          </b-tab>
          <b-tab :title="$t('mapping.transformerConfigurationTransformer')">
            <TransformerConfiguration
              :tab-index="tabIndex"
              :transformer="transformer"
              :configurations.sync="configurations"
              :parent-field-type="fieldType"
            />
          </b-tab>
        </b-tabs>
      </div>
    </div>
    <div v-else>
      <h5 class="text-center">
        {{ $t("mapping.configurationNoTransformer") }}
      </h5>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Basic from "@/components/Mappings/Transformers/Structure/Configuration/Basic.vue";
import TransformerConfiguration from "@/components/Mappings/Transformers/Structure/Configuration/TransformerConfiguration.vue";
import { UPDATE_TRANSFORMER } from "@/core/services/store/mappingTransformer.module";
import Conditions from "@/components/Mappings/Transformers/Structure/Configuration/Conditions.vue";

export default {
  components: { Conditions, Basic, TransformerConfiguration },
  props: {
    fieldType: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      key: 1,
      tabIndex: 0
    };
  },
  computed: {
    ...mapGetters("mapping", { library: "transformers" }),
    ...mapGetters("mappingTransformer", [
      "selectedTransformer",
      "selectedTransformerId",
      "vars"
    ]),
    title: function () {
      if (!this.originalTransformer) {
        return this.$t("mapping.transformer");
      }
      let title = this.originalTransformer.label;
      if (this.transformer.label) {
        title = " (" + title + ")";
        title = this.transformer.label + title;
      }
      return title;
    },
    originalTransformer: function () {
      if (!this.transformer?.transformer_name) return;
      return this.library.find(
        t => t.name === this.transformer.transformer_name
      );
    },
    transformerOutput: {
      get: function () {
        let parts = this.transformer.config.output.split(".");
        if (parts[0] === "output") {
          parts.shift();
        }
        return parts.join(".");
      },
      set: function (newName) {
        this.transformer.config.output = "output." + newName;
      }
    },
    transformer: {
      get: function () {
        return this.selectedTransformer;
      },
      set: function (value) {
        const payload = {
          id: value.id,
          transformer: value
        };
        this[UPDATE_TRANSFORMER](payload);
      }
    },
    configurations: {
      get: function () {
        let configs = [];
        Object.keys(this.originalTransformer.config).forEach(key => {
          if (key === "input" || key === "output") return;
          let config = Object.assign({}, this.originalTransformer.config[key]);

          if (key === "phpeditor") {
            config = {
              ...config,
              disabled: true
            };
          }

          config.name = key;
          config.value = this.transformer.config[key];
          if (config.required && !config.value) {
            config.value = this.getDefaultValue(config);
          }
          configs.push(config);
        });
        return configs;
      },
      set: function (value) {
        let transformer = this.transformer;
        value.forEach(config => {
          transformer.config[config.name] = config.value;
        });
        this.transformer = transformer;
      }
    }
  },
  watch: {
    selectedTransformerId: function () {
      this.key++;
    }
  },
  mounted() {},
  methods: {
    ...mapActions("mappingTransformer", [UPDATE_TRANSFORMER]),
    getDefaultValue(config) {
      if (config.type === "filter") {
        return {
          type: "group",
          operator: "and",
          children: [
            {
              type: "filter",
              field: "",
              operator: "",
              value: "",
              valid: false
            }
          ]
        };
      }
    }
  }
};
</script>
